import get from 'lodash/get'
const state = {
    workstation: null,
    availableWorkstations: []
};

const getters = {
    getWorkstation: state => state.workstation,
    getWorkstationId: state => state.workstation?.id,
    getAvailableWorkstations: state => state.availableWorkstations,
    getConfig: (state) => (key, fallback) => get(state.workstation, `data.${key}`, fallback)
};

const mutations = {
    changeWorkstation: (state, payload) => {
        console.log('workstation/changeWorkstation', payload)
        state.workstation = payload;
    },
    setAvailableWorkstations: (state, payload) => {
        console.log('workstation/setAvailableWorkstations', payload)
        state.availableWorkstations = payload;
        if (state.workstation === null && payload.length) {
            state.workstation = payload[0]
        }
    }
};

// if This will not work we will need to save it in a constant Namespace
export default {
    namespaced: true,
    state,
    getters,
    mutations
};
